"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactBar = void 0;
var react_1 = __importStar(require("react"));
require("./ContactBar.scss");
var config_1 = require("@app/shared/config");
var matomo_1 = require("@app/shared/matomo");
var HELP_TEXT = 'Need Help?';
var initialState = {
    contactButtonText: HELP_TEXT
};
var ContactBar = /** @class */ (function (_super) {
    __extends(ContactBar, _super);
    function ContactBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.handleMouseOver = function () {
            _this.setState({ contactButtonText: config_1.Config.CONTACT_EMAIL });
        };
        _this.handleMouseOut = function () {
            _this.setState({ contactButtonText: HELP_TEXT });
        };
        return _this;
    }
    ContactBar.prototype.render = function () {
        var _this = this;
        var handleTermsClick = function () {
            if (_this.props.openTermsModal) {
                _this.props.openTermsModal();
            }
        };
        var contactElement = !!this.props.isMobile ?
            react_1.default.createElement("div", { className: "contact-bar" },
                react_1.default.createElement("div", { className: "help has-text-centered" },
                    react_1.default.createElement("span", null,
                        "Version ",
                        process.env.APP_VERSION)),
                react_1.default.createElement("div", { className: "has-text-centered" },
                    react_1.default.createElement("a", { href: "mailto:" + config_1.Config.CONTACT_EMAIL, className: "button button-yellow", "data-test": "contact-link", onClick: function () { new matomo_1.MatomoTracker().trackEvent('User', 'Needs Help'); }, onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut }, this.state.contactButtonText)),
                react_1.default.createElement("div", { className: "help has-text-centered" },
                    react_1.default.createElement("span", null,
                        "\u00A9 ",
                        new Date().getFullYear(),
                        " Hasbro"))) :
            react_1.default.createElement("div", { className: "contact-bar" },
                react_1.default.createElement("div", { className: "has-text-centered" },
                    react_1.default.createElement("a", { href: "mailto:" + config_1.Config.CONTACT_EMAIL, className: "button button-yellow", "data-test": "contact-link", onClick: function () { new matomo_1.MatomoTracker().trackEvent('User', 'Needs Help'); }, onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut }, this.state.contactButtonText)),
                react_1.default.createElement("div", { className: "help has-text-centered" },
                    react_1.default.createElement("a", { onClick: handleTermsClick }, "Terms of Service"),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("span", null,
                        "\u00A9 ",
                        new Date().getFullYear(),
                        " Hasbro"),
                    react_1.default.createElement("span", null, "\u00A0\u00B7\u00A0"),
                    react_1.default.createElement("span", null,
                        "Version ",
                        process.env.APP_VERSION),
                    this.props.asperaVersion &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("br", null),
                            react_1.default.createElement("span", null,
                                "Aspera Version ",
                                this.props.asperaVersion))));
        return (react_1.default.createElement(react_1.default.Fragment, null, contactElement));
    };
    return ContactBar;
}(react_1.Component));
exports.ContactBar = ContactBar;
